import { QUERY_DEFAULTS } from '@/shared/lib/constants';
import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { connectorKeys } from '@/shared/lib/query/queryKeys';

import { getConnectorsApi } from '@/entities/connector/api';
import type { ConnectorListParams, ConnectorListResponse } from '@/entities/connector/types';

const CONNECTOR_POLL_INTERVAL_MS = 5000;

export const useConnectors = (params?: ConnectorListParams) => {
  return useQueryWithBoundary<ConnectorListResponse>({
    ...DEFAULT_QUERY_OPTIONS,
    queryKey: connectorKeys.lists(params),
    queryFn: () => getConnectorsApi(params),
    staleTime: QUERY_DEFAULTS.STALE_TIME.SHORT,
    gcTime: QUERY_DEFAULTS.GC_TIME.MEDIUM,
    refetchInterval: CONNECTOR_POLL_INTERVAL_MS,
  });
};
